// The on-screen number pad, shared by the single number box, the "several
// boxes" questions (2026-10-12) and the "fraction entry" questions
// (2026-10-13). It only reports which key was pressed; the practice screen
// decides what that does to the answer.

export function NumberPad({
  disabled,
  deleteDisabled,
  digitsOnly = false,
  onKey,
  onDelete,
}: {
  disabled: boolean;
  deleteDisabled: boolean;
  // Fraction entry: whole numbers only, so no minus sign and no point.
  digitsOnly?: boolean;
  onKey: (key: string) => void;
  onDelete: () => void;
}) {
  return (
    <div
      role="group"
      aria-label="Number pad"
      className="grid grid-cols-3 gap-2.5 [@media(orientation:landscape)_and_(max-height:900px)_and_(min-width:700px)]:grid-cols-4"
    >
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
        <button
          key={digit}
          type="button"
          disabled={disabled}
          className="dm-key"
          onClick={() => {
            onKey(digit);
          }}
        >
          {digit}
        </button>
      ))}
      {!digitsOnly && (
        <button
          type="button"
          disabled={disabled}
          aria-label="Minus sign"
          className="dm-key"
          onClick={() => {
            onKey('-');
          }}
        >
          −
        </button>
      )}
      <button
        type="button"
        disabled={disabled}
        // On its own it still sits in the middle, under the 8.
        className={digitsOnly ? 'dm-key col-start-2' : 'dm-key'}
        onClick={() => {
          onKey('0');
        }}
      >
        0
      </button>
      {!digitsOnly && (
        <button
          type="button"
          disabled={disabled}
          aria-label="Decimal point"
          className="dm-key"
          onClick={() => {
            onKey('.');
          }}
        >
          .
        </button>
      )}
      <button
        type="button"
        disabled={disabled || deleteDisabled}
        aria-label="Delete last digit"
        className="dm-key col-span-3 text-lg [@media(orientation:landscape)_and_(max-height:900px)_and_(min-width:700px)]:col-span-1 [@media(orientation:landscape)_and_(max-height:900px)_and_(min-width:700px)]:col-start-4 [@media(orientation:landscape)_and_(max-height:900px)_and_(min-width:700px)]:row-span-4 [@media(orientation:landscape)_and_(max-height:900px)_and_(min-width:700px)]:row-start-1"
        onClick={onDelete}
      >
        ⌫ Delete
      </button>
    </div>
  );
}
